export const STATUS_FILTERS = [
  { text: 'Active', value: 'true' },
  { text: 'Inactive', value: 'false' },
]

export const MIN_PASSWORD_LENGTH = 6
